import cacheManager from '../loading/resources/cacheManager';

import { reportError } from './ErrorReporting';
import stateCacheService from './StateCache';

const dataCleanUpService = {
    async deleteAssessmentData(assessmentRunId) {
        try {
            await cacheManager.getCacheHandler().deleteAssessmentDataCache(assessmentRunId);
        } catch (error) {
            reportError(error);
        }
    },

    async deleteUserData(assessmentRunId, userId) {
        try {
            await stateCacheService.getStateCacheInstance().removeAllCachedTestData(assessmentRunId, userId);
        } catch (error) {
            reportError(error);
        }
    },

    async deleteAllDataFromOtherAssessments(assessmentRunIdsToKeep) {
        await cacheManager.getCacheHandler().deleteCachesForOtherAssessments(assessmentRunIdsToKeep);
    },

    async deleteAssessmentAndUserData(assessmentRunId, userId) {
        return Promise.all([
            dataCleanUpService.deleteAssessmentData(assessmentRunId),
            dataCleanUpService.deleteUserData(assessmentRunId, userId),
        ]);
    },

    async deleteAllDataFromAllAssessments(flagAsTriggeredOnExit = false) {
        try {
            await cacheManager.getCacheHandler().deleteAllAssessmentDataCaches();
            if (flagAsTriggeredOnExit) {
                window.InsperaPlayer.deleteAllAssessmentDataCachesIsTriggered = true;
            }
        } catch (error) {
            reportError(error);
        }
    },

    assureAssessmentDataDeletionOnUnload() {
        window.addEventListener('beforeunload', () => {
            if (!window.InsperaPlayer.deleteAllAssessmentDataCachesIsTriggered) {
                dataCleanUpService.deleteAllDataFromAllAssessments();
            }
        });
    },
};

export default dataCleanUpService;
